module.exports = __webpack_public_path__ + "img/logo.248c41c0.png";